module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "disabled": _vm.disabled
    }
  }, [_c('option')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f75e78d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/modules/Select2/Select2.vue
// module id = 340
// module chunks = 0